import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';

function EditOrganizerUserModal(props) {
  const { editOrganizerUser, organizerUser, confirmBtnText, ...rest } = props;
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setForm({
      firstName: organizerUser?.firstName,
      lastName: organizerUser?.lastName,
      phoneNumber: organizerUser?.phoneNumber,
      street: organizerUser?.street,
      zipCode: organizerUser?.zipCode,
      city: organizerUser?.city,
      nationality: organizerUser?.nationality,
    });
    setErrors({});
  }, [props.show]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const findFormErrors = () => {
    const { firstName, lastName, phoneNumber, zipCode, city } = form;
    const newErrors = {};
    const validNumberRegex = /^[0-9]+$/;
    const validTextRegex = /^[A-Öa-ö\- ]*$/;
    // firstName errors
    if (!firstName || firstName === '') {
      newErrors.firstName = 'Du måste ange ett namn.';
    } else if (validTextRegex.test(firstName) === false) {
      newErrors.firstName = 'Endast bokstäver tillåtet';
    }
    // lastName errors
    if (!lastName || lastName === '') {
      newErrors.lastName = 'Du måste ange ett namn.';
    } else if (validTextRegex.test(lastName) === false) {
      newErrors.lastName = 'Endast bokstäver tillåtet';
    }
    // phoneNumber errors
    if (phoneNumber !== '') {
      if (validNumberRegex.test(phoneNumber) === false) {
        newErrors.phoneNumber = 'Endast siffror tillåtet.';
      }
    }
    // zipCode errors
    if (zipCode !== '' || zipCode) {
      if (validNumberRegex.test(zipCode) === false) {
        newErrors.zipCode = 'Endast siffror tillåtet.';
      }
    }
    // city errors
    if (city !== '') {
      if (validTextRegex.test(city) === false) {
        newErrors.city = 'Endast bokstäver tillåtet.';
      }
    }

    return newErrors;
  };

  const handleSubmit = () => {
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      editOrganizerUser(form);
    }
  };

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Redigera användare</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <p>Redigera användare för arrangörskontot</p>
          <Form.Group className='mt-2'>
            <Form.Label>Förnamn</Form.Label>
            <Form.Control
              type='text'
              name='firstName'
              defaultValue={form?.firstName}
              placeholder='Ange förnamn'
              onChange={(e) => setField('firstName', e.target.value)}
              isInvalid={!!errors.firstName}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.firstName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Efternamn</Form.Label>
            <Form.Control
              type='text'
              name='lastName'
              defaultValue={form?.lastName}
              placeholder='Ange efternamn'
              onChange={(e) => setField('lastName', e.target.value)}
              isInvalid={!!errors.lastName}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.lastName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Telefonnummer</Form.Label>
            <Form.Control
              type='text'
              name='phoneNumber'
              defaultValue={form?.phoneNumber}
              placeholder='Ange telefonnummer'
              onChange={(e) => setField('phoneNumber', e.target.value)}
              isInvalid={!!errors.phoneNumber}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.phoneNumber}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Gatuadress</Form.Label>
            <Form.Control
              type='text'
              name='street'
              placeholder='Ange gatuadress'
              defaultValue={form?.street}
              onChange={(e) => setField('street', e.target.value)}
              isInvalid={!!errors.street}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.street}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Postnummer</Form.Label>
            <Form.Control
              type='text'
              name='zipCode'
              placeholder='Ange postnummer'
              defaultValue={form?.zipCode}
              onChange={(e) => setField('zipCode', e.target.value)}
              isInvalid={!!errors.zipCode}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.zipCode}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Postort</Form.Label>
            <Form.Control
              type='text'
              name='city'
              placeholder='Ange postort'
              defaultValue={form?.city}
              onChange={(e) => setField('city', e.target.value)}
              isInvalid={!!errors.city}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.city}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId='nationality' className='mt-2'>
            <Form.Label>Nationalitet</Form.Label>
            <Form.Select
              name='nationality'
              value={form?.nationality}
              onChange={(e) => setField('nationality', e.target.value)}
              isInvalid={!!errors.nationality}
            >
              <option value='none' hidden>
                Välj ett land
              </option>
              <option value='Sweden'>Sverige</option>
              <option value='Denmark'>Danmark</option>
              <option value='Norway'>Norge</option>
              <option value='Finland'>Finland</option>
            </Form.Select>
            <Form.Control.Feedback type='invalid'>
              {errors.nationality}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button onClick={handleSubmit} className='mt-2'>
          {confirmBtnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditOrganizerUserModal;
